import {getReportParams, report} from 'app/middleware/report';

function reportCellularPorting({actionType, status, messageText, subscriber = '', param1 = '', param2 = '', idNumber = '', customerName = ''}) {
  const reportParams = getReportParams();
  reportParams.channel = 'WebsitePrivate';
  reportParams.area = 'SelfCare';
  reportParams.subArea = 'Cellular Porting';
  reportParams.actionType = actionType;
  reportParams.status = status;
  reportParams.messageText = messageText;
  reportParams.subscriber = subscriber;
  reportParams.param1 = param1;
  reportParams.param2 = param2;
  reportParams.idNumber = idNumber;
  reportParams.customerName = customerName;
  report(reportParams);
}

function userDetailsFields(userDetails) {
  return {
    idNumber: userDetails?.IDNumber || '',
    customerName: `${userDetails?.firstName} ${userDetails?.lastName}`,
  };
}

export function dwhPortingEntrance({isOpened, userDetails}) {
  reportCellularPorting({
    actionType: 'Cellular Porting Process Entrance',
    status: 'Ongoing',
    messageText: isOpened ? 'Cellular Porting Process Entrance Displayed' : 'Out of Working Hours',
    subscriber: '',
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingPhonePageButtonClick({subscriber, userDetails}) {
  reportCellularPorting({
    actionType: 'Cellular Porting Page',
    status: 'Ongoing',
    messageText: 'Cellular Porting Page Button Click',
    subscriber: subscriber ?? '',
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingOtpPageDisplayed({subscriber, userDetails}) {
  reportCellularPorting({
    actionType: 'OTP Code Page',
    status: 'Ongoing',
    messageText: 'OTP Code Page Displayed',
    subscriber: subscriber ?? '',
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingOtpPageButtonClick({subscriber, userDetails}) {
  reportCellularPorting({
    actionType: 'Cellular Porting Page',
    status: 'Ongoing',
    messageText: 'OTP Code Page Button Clicked',
    subscriber: subscriber ?? '',
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingCodePageDisplayed({subscriber, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Code Page',
    status: 'Ongoing',
    messageText: 'Porting Code Page Displayed',
    subscriber: subscriber ?? '',
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingCodePageButtonClick({subscriber, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Code Page',
    status: 'Ongoing',
    messageText: 'Porting Code Page Button Clicked',
    subscriber: subscriber ?? '',
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingPageDisplayed({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Page',
    status: 'Ongoing',
    messageText: 'Porting Page Displayed',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingPageButtonClick({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Page',
    status: 'Ongoing',
    messageText: 'Porting Page Button Clicked',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingEsimPopupDisplayed({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Page',
    status: 'Ongoing',
    messageText: 'eSim Activation Popup Displayed',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingEsimPopupButtonClick({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Page',
    status: 'Ongoing',
    messageText: 'eSim Activation Popup Button Clicked',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingTimeDefineDisplayed({subscriber, param1, param2, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Page',
    status: 'Completed',
    messageText: 'Porting Time Define Displayed',
    subscriber: subscriber ?? '',
    param1,
    param2,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingInfoPopupDisplayed({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Before Porting Info Popup',
    status: 'Ongoing',
    messageText: 'Before Porting Info Popup Displayed',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingInfoPopupClick({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Before Porting Info Popup',
    status: 'Ongoing',
    messageText: 'Before Porting Info Popup Clicked',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}

export function dwhPortingTimeDelayDisplayed({subscriber, param1, userDetails}) {
  reportCellularPorting({
    actionType: 'Porting Page',
    status: 'Error',
    messageText: 'Porting Time Delay Displayed',
    subscriber: subscriber ?? '',
    param1,
    ...userDetailsFields(userDetails),
  });
}
